<template>
    <div class="card-header">
        <div class="card-img">
            <div class="card-img-container">
                <template v-if="null === this.level && 0 === this.amount">
                    <div class="card-img-container-label body-l">{{ this.placeholderLevel }}</div>
                </template>
                <template v-if="0 < this.level">
                    <div class="card-img-container-label body-l">Level</div>
                    <div class="card-img-container-data body-l">{{ this.level }}</div>
                </template>
                <template v-if="0 < this.amount">
                    <div class="card-img-container-label body-l">Available</div>
                    <div class="card-img-container-data body-l">{{ this.amount }}</div>
                </template>
            </div>
        </div>
        <div class="card-title">
            <h3 class="title-m content-1">{{ this.name }}</h3>
            <p class="card-title-description body-s content-2">
                {{ this.description }}
            </p>
        </div>
    </div>
</template>

<style scoped>
.card-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.card-img {
    width: 100%;
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 16px;
    background: url(/src/assets/img/card-img-placeholder.webp);
    background-size: cover;
    aspect-ratio: 16/9;
}

.card-img-container {
    display: flex;
    align-items: flex-start;
    gap: 2px;
}

.card-img-container-label {
    text-transform: uppercase;
    display: flex;
    padding: 4px 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(30, 34, 35, 0.80);
    color: var(--content-3-pair);
}

.card-img-container-data {
    display: flex;
    padding: 4px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--background-3);
    color: var(--content-3-pair);
}

.card-title {
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
}

.card-title-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>

<script>
export default {
    name: 'CardHeaderComponent',
    props: {
        level: {
            type: [Number, null],
            default: null
        },
        amount: {
            type: Number,
            default: 0
        },
        name:  {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        placeholderLevel: {
            type: String,
            default: 'Unbuilt'
        }
    }
}
</script>